import { ResponsivePie } from '@nivo/pie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessMetrics, ProcessShare } from '../../types/metrics';

interface ProcessShareChartProps {
  shareData: ProcessShare[];
  metrics: ProcessMetrics;
}

const ProcessShareChart: React.FC<ProcessShareChartProps> = ({
  shareData,
  metrics,
}) => {
  const { t } = useTranslation('app');

  const pieData = shareData.map(item => ({
    id: item.activityType,
    label: t(item.activityType),
    value: item.percentage,
    color: item.color,
  }));

  return (
    <div className="bg-app-panel-dark rounded-lg p-4">
      <h3 className="mb-2 text-lg font-semibold text-white">
        {t('Activity Summary')}
      </h3>
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h4 className="text-lg font-semibold text-white">{t('PICKING')}</h4>
          <div className="mt-2 space-y-1">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-300">{t('COST')}</span>
              <span className="text-lg font-medium text-white">
                $ {metrics.cost}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-300">{t('TIME')}</span>
              <span className="text-lg font-medium text-white">
                {metrics.time} h
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="relative h-[300px]">
        <ResponsivePie
          data={pieData}
          margin={{ top: 20, right: 20, bottom: 80, left: 20 }}
          innerRadius={0.6}
          padAngle={0.5}
          cornerRadius={3}
          activeOuterRadiusOffset={8}
          colors={{ datum: 'data.color' }}
          borderWidth={1}
          borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
          enableArcLinkLabels={false}
          arcLabelsSkipAngle={10}
          arcLabelsTextColor="#ffffff"
          legends={[
            {
              anchor: 'bottom',
              direction: 'column',
              justify: false,
              translateX: 0,
              translateY: 60,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemTextColor: '#ffffff',
              itemDirection: 'left-to-right',
              itemOpacity: 1,
              symbolSize: 18,
              symbolShape: 'circle',
            },
          ]}
        />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
          <div className="text-sm text-gray-400">{t('TRAVELLING')}</div>
          <div className="text-2xl font-bold text-white">
            {metrics.travellingTotal}%
          </div>
          <div className="text-sm text-gray-400">{t('HANDLING & PICKING')}</div>
          <div className="text-2xl font-bold text-white">
            {metrics.handlingAndPicking}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessShareChart;
